module.exports = __webpack_public_path__ + "media/28-01a.b12e39b0.mp4";